import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";

export const StudentLateSubmissionBanner = () => {
  return (
    <Banner className="page-block-width" kind="info">
      {t("warning.late_submission_alert_student")}
    </Banner>
  );
};
